export const PC_BUTTON_SIZE = 10
export const MOBILE_BUTTON_SIZE = 5

export const PREVIEW_PAGE_SIZE = 5
export const LIST_PAGE_SIZE = 20
